import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLampFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.7949 2.14259C7.65693 2.25114 4.30078 5.57118 4.30078 9.70118C4.30078 12.0401 5.38227 14.1213 7.07617 15.5H11.2539V11.4102L9.59766 9.75001C9.30469 9.46 9.30469 8.98947 9.59766 8.68946C9.89062 8.39945 10.3653 8.39945 10.6582 8.68946L12.002 10.0391L13.3457 8.68946C13.6386 8.39945 14.1132 8.39945 14.4062 8.68946C14.6993 8.98947 14.6993 9.46 14.4062 9.75001L12.7539 11.4102V15.5H16.9453C19.0126 13.7995 20.1613 11.0333 19.5371 8.08985C18.9204 5.18986 16.5425 2.89079 13.6094 2.30079C12.9939 2.17829 12.3861 2.12708 11.7949 2.14259ZM8.52344 17V18.2109C8.52344 20.1109 10.105 21.6406 12.0098 21.6406C13.9141 21.6406 15.4941 20.1109 15.4941 18.2109V17H8.52344Z",
		fill: "currentColor"
	})
});
export default SvgLampFill;
